
import MessageEdit from "../../../assets/outline/MessageEdit.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MessageEditIcon({ className, dataTestid = "MessageEditIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MessageEdit data-testid={dataTestid} className={classes} {...rest} />
  );
}
